import React, { useEffect, useState } from "react";

//** MUI Components */
import { Paper, Typography } from "@mui/material";

import {
	FormField,
	Section,
	OneColumnStack,
	TwoColumnStack,
	RHFSelect,
	RHFTextField,
} from "@arp/react-ndbx";

import RHFAutocomplete from "../../coding/rhfAutocomplete/RHFAutocomplete.jsx";
//----------------------------------------------------------------
const AddressDetails = React.forwardRef((props, ref) => (
	<FormField ref={ref} Component={RHFAddressDetailsImpl} {...props} />
));

const RHFAddressDetailsImpl = React.forwardRef(
	(
		{
			accessToken,
			useFunction,
			autoCompleteLabel = "",
			autoCompleteLabelOption = "",
			autoCompleteName,
			autoCompleteOChange,
			name,
			error,
			size,
			title,
			streetNumberType = [],
			streetNameType = [],
			dataSet = {},
			resetAll = false,
			...props
		},
		ref
	) => {
		const [resetAllValues, setResetAllValues] = useState(resetAll);

		useEffect(() => {
			setResetAllValues(resetAll);
		}, [resetAll]);

		//----------------------------------------------------------------

		return (
			<Paper elevation={0} sx={{ outline: "0px solid red" }}>
				{title ? (
					<OneColumnStack>
						<Typography variant="h5">{title}</Typography>
					</OneColumnStack>
				) : null}
				<TwoColumnStack>
					<Section>
						<RHFTextField
							className="subvariant-text-input"
							variant="standard"
							name={`${name}LevelNumber`}
							label="Level number"
							controlIdentifier={`${name}-level-number`}
							sx={{ width: "100%" }}
							defaultValue={
								dataSet != null && resetAll === false
									? dataSet[`${name}LevelNumber`]
									: ""
							}
						/>
					</Section>
					<Section>
						<RHFTextField
							className="subvariant-text-input"
							variant="standard"
							name={`${name}UnitNumber`}
							label="Unit number"
							controlIdentifier={`${name}-unit-number`}
							sx={{ width: "100%" }}
							defaultValue={
								dataSet != null && resetAll === false
									? dataSet[`${name}UnitNumber`]
									: ""
							}
						/>
					</Section>
				</TwoColumnStack>
				<TwoColumnStack>
					<Section>
						<RHFTextField
							className="subvariant-text-input"
							variant="standard"
							name={`${name}StreetNumber`}
							label="Street number"
							controlIdentifier={`${name}-street-number`}
							sx={{ width: "100%" }}
							defaultValue={
								dataSet != null && resetAll === false
									? dataSet[`${name}StreetNumber`]
									: ""
							}
						/>
					</Section>
					<Section sx={{ paddingTop: 0.5 }}>
						<RHFSelect
							name={`${name}StreetNumberType`}
							label="Street number type"
							variant="standard"
							items={streetNumberType}
							controlIdentifier={`${name}-street-number-type`}
							sx={{ width: "100%" }}
							defaultValue={
								dataSet != null && resetAll === false
									? dataSet[`${name}StreetNumberType`]
									: ""
							}
						/>
					</Section>
				</TwoColumnStack>
				<TwoColumnStack>
					<Section>
						<RHFTextField
							className="subvariant-text-input"
							variant="standard"
							name={`${name}StreetName`}
							label="Street name"
							controlIdentifier={`${name}-street-name`}
							sx={{ width: "100%" }}
							defaultValue={
								dataSet != null && resetAll === false
									? dataSet[`${name}StreetName`]
									: ""
							}
						/>
					</Section>
					<Section sx={{ paddingTop: 0.5 }}>
						<RHFSelect
							name={`${name}StreetNameType`}
							label="Street name type"
							variant="standard"
							items={streetNameType}
							controlIdentifier={`${name}-street-name-type`}
							sx={{ width: "100%" }}
							defaultValue={
								dataSet != null && resetAll === false
									? dataSet[`${name}StreetNameType`]
									: ""
							}
						/>
					</Section>
				</TwoColumnStack>
				<OneColumnStack
					name="address-suburb"
					sx={{ maxWidth: { xs: "-webkit-fill-available" }, mt: 1 }}
				>
					<RHFAutocomplete
						defaultValue={
							dataSet != null && resetAllValues === false
								? dataSet[autoCompleteName]
								: ""
						}
						name={autoCompleteName}
						accessToken={accessToken}
						func={useFunction}
						functionType="query"
						label={autoCompleteLabel}
						labelOption="fullPostcode"
						onChange={(e) => autoCompleteOChange(e)}
						variant="standard"
						placeholder="post"
						freeSolo={false}
					/>
				</OneColumnStack>
			</Paper>
		);
	}
);

export default AddressDetails;
